import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { InputWrapper, InputError, TextInputExtended } from 'src/components';
import { store } from 'src/feature-app';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { OneFormState } from 'src/types';

interface emailProps {
	required?: boolean;
	name?: string;
	label?: string;
	disabled?: boolean;
	paddingTop?: string;
	paddingBottom?: string;
	setEmail?: (email: string) => void;
	setShowError?: (showError: boolean) => void;
}

export function Email(props: emailProps) {
	const { required, name, label, disabled, setEmail, setShowError } = props;

	const { register, errors } = useFormContext();
	const { formInfo }: OneFormState = store.getState();
	const [inputValue, setInputValue] = useState('');
	const [pristine, setPristine] = useState(true);
	const [emailError, setEmailError] = useState(false);
	const regExp =
		/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
	const { error, setError } = useOneFormContext();
	const dispatch = useDispatch();

	const checkEmailError = (value: string) =>
		!pristine && !regExp.test(value) && value?.length > 2;
	const handleChange = (e: any) => {
		setInputValue(e.target.value);
		setPristine(false);
	};

	useEffect(() => {
		if (checkEmailError(inputValue)) {
			setEmailError(true);
			if (setShowError) setShowError(true);
		} else {
			if (setEmail && !error) {
				setEmail(inputValue);
				setShowError(false);
			}
			if (!error) {
				dispatch({
					type: 'UPDATE_FIELDS',
					payload: { email: inputValue },
				});
			}
			setEmailError(false);
			setError(false);
		}
	}, [inputValue, pristine]);

	useEffect(() => {
		if ((!inputValue && error) || (error && checkEmailError(inputValue))) {
			setEmailError(true);
		} else {
			setEmailError(false);
		}
	}, [error]);

	return (
		<InputWrapper
			className="email-input-wrapper"
			notALayer={formInfo.notALayer}
			paddingTop={props.paddingTop}
			paddingBottom={props.paddingBottom}
		>
			<TextInputExtended
				name={name ? name : 'email'}
				label={label ? label : 'Email'}
				isFloating
				innerRef={register({
					required: {
						value: required ? required : false,
						message: 'Requerido',
					},
					pattern: {
						value: regExp,
						message: 'Solo se aceptan letras',
					},
				})}
				onChange={e => handleChange(e)}
				required={required ? required : false}
				disabled={disabled}
			/>
			{emailError && (
				<InputError className="input-error">
					Ejemplo: nombre@email.com
				</InputError>
			)}
		</InputWrapper>
	);
}
